import axios from 'axios';

// Configure axios with the backend API base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('vendorToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Remove Content-Type header for FormData to let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle network errors
    if (!error.response) {
      console.error('Network error:', error.message);
      return Promise.reject(
        new Error('Network error. Please check your connection.'),
      );
    }

    // Handle specific HTTP status codes
    switch (error.response.status) {
      case 401: {
        // Only force logout if we actually had a token (avoids nuking the
        // session on stray/edge-case 401s) and we're not already on /login
        // (avoids redirect loops).
        const hadToken = !!localStorage.getItem('vendorToken');
        if (hadToken && window.location.pathname !== '/login') {
          console.warn('Session expired (401) - logging out');
          localStorage.removeItem('vendorToken');
          window.location.href = '/login';
        }
        break;
      }
      case 403:
        console.error('Access forbidden:', error.response.data);
        break;
      case 404:
        console.error('Resource not found:', error.response.data);
        break;
      case 500:
        console.error('Server error:', error.response.data);
        break;
      default:
        console.error('API error:', error.response.data);
    }

    return Promise.reject(error);
  },
);

export default api;
